import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

export const AuthContext = createContext();

const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete axios.defaults.headers.common['Authorization'];
  }
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // --- FUNZIONE FETCHPROFILE MODIFICATA ---
  const fetchProfile = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      setAuthToken(token);
      try {
        const res = await axios.get('/api/users/profile');
        const profileData = res.data;

        // SOLUZIONE: Creiamo un oggetto 'user' standardizzato, proprio come fa l'API di login.
        // In questo modo, la struttura dei dati è sempre consistente.
        const standardizedUser = {
          id: profileData.id,
          name: profileData.fullName || profileData.name || profileData.username,
          role: profileData.role,
          isSuperAdmin: profileData.isSuperAdmin || false
        };
        
        setUser(standardizedUser); // Impostiamo l'utente con la struttura corretta
        return standardizedUser;

      } catch (error) {
        console.error("Errore nel fetch del profilo, token rimosso:", error);
        localStorage.removeItem('token');
        setAuthToken(null);
        setUser(null);
        return null;
      }
    }
    return null;
  };
	
  useEffect(() => {
    fetchProfile().finally(() => setLoading(false));
  }, []);

  const login = async (email, pw) => {
    const res = await axios.post('/api/auth/login', { email, password: pw });
    localStorage.setItem('token', res.data.token);
    setAuthToken(res.data.token);
    // La risposta del login contiene già un oggetto 'user' standardizzato
    setUser(res.data.user); 
    return res.data.user;
  };
  
  const logout = () => {
    localStorage.removeItem('token');
    setAuthToken(null);
    setUser(null);
  };
	
  if (loading) {
    return null; 
  }

  return (
    <AuthContext.Provider value={{ user, login, logout, fetchProfile, isAuthenticated: !!user, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};